/* eslint-disable camelcase */
import { createAction, handleActions } from 'redux-actions';
import { useService } from '@piwikpro/platform';
import { MetaSitePermissionsForUser } from '../../../../interfaces';

const inUnderMetaSitePermissionRoute = new RegExp('/meta-sites/(.*)/permissions/users(.*)');

export const metaSitePermissionsForUsersFetchInitialized = createAction(
  '@platform/query/metaSitePermissionsForUsers/list/init',
);
export const metaSitePermissionsForUsersFetchSucceeded = createAction(
  '@platform/query/metaSitePermissionsForUsers/list/success',
  (payload: any) => payload,
);
export const metaSitePermissionsForUsersFetchFailed = createAction(
  '@platform/query/metaSitePermissionsForUsers/list/failed',
);
export const metaSitePermissionsForUserUpdateSucceeded = createAction(
  '@platform/command/metaSitePermissionsForUsers/update/success',
  (payload: any) => payload,
);
export const metaSitePermissionsForUserUpdateFailed = createAction(
  '@platform/command/metaSitePermissionsForUsers/update/failed',
);

interface MetaSitePermissionsState {
  isLoading: boolean
  failed: boolean
  permissions: MetaSitePermissionsForUser[]
  total: number
}

const initialState: MetaSitePermissionsState = {
  isLoading: false,
  permissions: [],
  total: 0,
  failed: false,
};

// TODO: move to proper crate
export const fetchMetaSitePermissionsForUsers = (
  id: string,
  filters: { search: string, offset?: number, limit?: number } = { search: '' },
) => async (dispatch: Function) => {
  const httpClient = useService('HttpCrate.httpClient');
  const notifyOnFail = useService('NotificationCrate.interceptors.NotifyOnFail');
  const config = useService('config');

  dispatch(metaSitePermissionsForUsersFetchInitialized());

  try {
    const queryParams = {
      offset: filters.offset,
      limit: filters.limit,
      search: filters.search || '',
    };
    const resp = await httpClient.request({
      endpoint: `${config.get('ACCESS_CONTROL_URL')}/meta-site/${id}/permission/user`,
      queryParams,
      method: 'GET',
    }).intercept(notifyOnFail).jsonApi().send();

    dispatch(metaSitePermissionsForUsersFetchSucceeded(resp));
  } catch (err) {
    dispatch(metaSitePermissionsForUsersFetchFailed());
  }
};

export const updateMetaSitePermissionsForUser = (
  metaSiteId: string, userId: string, attributes: any,
) => async (dispatch: Function) => {
  const httpClient = useService('HttpCrate.httpClient');
  const notifyAboutUpdate = useService('NotificationCrate.interceptors.NotifyAboutUpdate');
  const config = useService('config');

  try {
    await httpClient.request({
      endpoint: `${config.get('ACCESS_CONTROL_URL')}/meta-site/${metaSiteId}/permission/user/${userId}`,
      method: 'POST',
      body: {
        data: {
          type: 'meta-site/permission/user',
          attributes,
        },
      },
    }).intercept(notifyAboutUpdate).jsonApi().send();

    dispatch(metaSitePermissionsForUserUpdateSucceeded({ id: userId, attributes }));
  } catch (err) {
    dispatch(metaSitePermissionsForUserUpdateFailed());
    throw err;
  }
};

const reducer = handleActions<MetaSitePermissionsState, any>({
  [metaSitePermissionsForUsersFetchInitialized.toString()]: state => ({
    ...state,
    failed: false,
    isLoading: true,
  }),
  [metaSitePermissionsForUsersFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    permissions: payload.data,
    total: payload.meta.total,
  }),
  [metaSitePermissionsForUsersFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  [metaSitePermissionsForUserUpdateSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    permissions: state.permissions.map(
      permission => (permission.id === payload.id
        ? {
          ...permission,
          attributes:
            { ...permission.attributes, permission: payload.attributes.permission },
        }
        : permission),
    ),
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!inUnderMetaSitePermissionRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
